<style lang="less">
  @import "./ParkingPosition.less";
</style>

<template>
  <div class="parking-position">
    <van-button type="info" size="large" @click="toShowMediaPageFn">{{mediaType===9?'查看停车照片':'查看停车视频'}}</van-button>
    <div id="mapParking"></div>
  </div>
</template>

<script>
import ParkingPosition from './ParkingPosition.js'
export default {
  ...ParkingPosition
}
</script>
